"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Inner = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')({
  width: '100%',
  overflow: 'hidden'
});
const Inner = exports.Inner = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  gridAutoFlow: 'column',
  gridAutoColumns: 'minmax(150px, 1fr)',
  justifyContent: 'center',
  justifyItems: 'center',
  columnGap: theme.spacing(3)
}));
